import { SuperAdminService } from "services/superAdminService";

class PlansSAService extends SuperAdminService<any> {
  constructor() {
    super("plans");
  }

  create = (data: any): Promise<any> => {
    return this.post(data);
  }

  update = (id: number, data: any): Promise<any> => {
    return this.put(id, data);
  }
}
export default new PlansSAService();
